import React from 'react'

const EnVivoSecciones = ({ secciones, seccionIdx, porcentajeTotal }) => {
  const siguiente = secciones[seccionIdx + 1]

  return (
    <div className="space-y-2">
      {siguiente ? (
        <p className="text-sm text-muted-foreground text-center">
          Siguiente: <span className="font-medium text-foreground">{siguiente.nombre}</span>{' '}
          <span className="text-muted-foreground">
            · {Math.floor(siguiente.duracion_seg / 60)}:{(siguiente.duracion_seg % 60).toString().padStart(2, '0')}
          </span>
        </p>
      ) : (
        <p className="text-sm text-muted-foreground text-center italic">Ultima seccion</p>
      )}
      <div className="w-full bg-slate-200 rounded-full h-2 overflow-hidden">
        <div
          className="bg-blue-600 h-full transition-all duration-300"
          style={{ width: `${porcentajeTotal}%` }}
        />
      </div>
      <p className="text-xs text-muted-foreground text-center">
        Seccion {seccionIdx + 1} de {secciones.length}
      </p>
    </div>
  )
}

export default EnVivoSecciones
